export const SPECS = {
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems',
  UseDeliveryOptionsLibInExpress: 'specs.ecom.UseDeliveryOptionsLibInExpress',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ErrorHandlerOnCheckout: 'specs.ecom.ErrorHandlerOnCheckout',
  UseConvertedPricesInExpress: 'specs.ecom.UseConvertedPricesInExpress',
  FixCarrierIdForSelectShippingOptionExpress: 'specs.ecom.FixCarrierIdForSelectShippingOptionExpress'
};
//# sourceMappingURL=SPECS.js.map